// Canonical list of AI Wins admins — single source of truth for admin gating.
export const ADMIN_EMAILS = [
  'nbennett@litehouseinc.com',
  'bbryan@litehouseinc.com',
  'dchristensen@litehouseinc.com',
  'thale@litehouseinc.com',
];

export function isAdminEmail(email) {
  return ADMIN_EMAILS.includes((email || '').toLowerCase());
}
